import styled from "styled-components";
import DropdownIcon from "src/img/arrow-down-sign-to-navigate.svg";
import { portalColors } from "./BusinessPortalComponents";

const DropDownOptions = styled.select`
    height: 42px;
    width: ${p => p.width || "11.125rem"};
    max-width: 100%;
    border-radius: 8px;
    background: ${portalColors.surfaceSoft} 0% 0% no-repeat padding-box;
    box-shadow: none;
    border: 1px solid ${portalColors.border};
    padding: 0.3em 1.1em;
    color: ${portalColors.text};
    font-size: 0.875rem;
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 700;
    background-image: url("${DropdownIcon}");
    background-repeat: no-repeat;
    background-position-x: 97%;
    background-position-y: 50%;
    appearance: none;

    &:focus {
        outline: none;
        border-color: ${portalColors.text};
        box-shadow: 0 0 0 4px ${portalColors.blueSoft};
    }

    &:disabled {
        background-color: ${portalColors.surfaceTertiary};
        color: ${portalColors.textSoft};
        cursor: not-allowed;
    }
`;

export default DropDownOptions;
